"use client";

import {default as Moment, default as moment} from "moment";
import React, {useEffect, useRef, useState} from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import {
    CustomProvider,
    DateRangePicker,
    Stack,
    Tooltip,
    Whisper,
} from "rsuite";
import "rsuite/dist/rsuite.min.css";
import es_ES from "rsuite/locales/es_ES";
import {ReactComponent as ArrowDown} from "../../../../../assets/elevva-pro-icons/arrowDown.svg";
import {instanceMob, Loadingspinner} from "../../../../../utils/utils";
import "./schedule.css";

export default function ScheduleChart() {
    const dataFrecuency = [
        {id: 1, name: "Últimos 7 días", valor: "l7"},
        {id: 2, name: "Último mes", valor: "l30"},
        {id: 3, name: "Últimos 3 meses", valor: "l90"},
        {id: 4, name: "Último Año", valor: "l365"},
    ];
    const [dataService, setDataService] = useState("");
    const [dataLocation, setDataLocation] = useState("");
    const [data, setData] = useState([]);
    const [maxValue, setMaxValue] = useState(0);
    const [frecuency, setFrecuency] = useState("l7");
    const [isLoading, setIsLoading] = useState(false);
    const [listServices, setListServices] = useState([]);
    const [listLocations, setListLocations] = useState([]);
    const [modalError, setModalError] = useState(null);
    const [dateRange, setDateRange] = useState(null);
    const [Modalpicker, setModalpicker] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isServiceOpen, setIsServiceOpen] = useState(false);
    const [isLocationOpen, setIsLocationOpen] = useState(false);
    const [isFrecuencyOpen, setIsFrecuencyOpen] = useState(false);
    const menuRef = useRef(null);
    const [hasScroll, setHasScroll] = useState(false);

    function picker() {
        setModalpicker(
            <CustomProvider locale={es_ES}>
                <Stack
                    id="schedule-administrator"
                    direction="column"
                    alignItems="flex-start"
                    spacing={6}
                    className="col-4"
                >
                    {dateRange ? (
                        <DateRangePicker
                            value={dateRange}
                            onChange={handleDateApplyEvent}
                            format="dd/MM/yyyy"
                            character=" – "
                            caretAs={ArrowDown}
                            placeholder="Seleccionar fecha"
                        />
                    ) : (
                        <DateRangePicker
                            onChange={handleDateApplyEvent}
                            format="dd/MM/yyyy"
                            character=" – "
                            caretAs={ArrowDown}
                            placeholder="Seleccionar fecha"
                        />
                    )}
                </Stack>
            </CustomProvider>
        );
    }

    const handleDateApplyEvent = (event, picker) => {
        if (event) {
            let startDate = event[0];
            let endDate = event[1];
            if (startDate && endDate) {
                setStartDate(Moment(startDate).format("YYYY-MM-DD"));
                setEndDate(Moment(endDate).format("YYYY-MM-DD"));
            }
        } else {
            setDateRange(null);
            setEndDate(Moment());
            setStartDate(Moment().subtract(7, "days"));
        }
    };

    function getListServices() {
        setIsLoading(true);
        instanceMob
            .get(`admin/service?no_paginate=True`)
            .then((res) => res.data)
            .then((data) => {
                let dataRes = data.results;
                let dataTransform = dataRes.map((item) => ({
                    id: item.id,
                    name: item.name,
                    valor: item.id,
                }));
                setDataService(Number(dataTransform[0].id));
                setListServices(dataTransform);
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setIsLoading(false);
            });
    }

    function getListLocations() {
        setIsLoading(true);
        instanceMob
            .get(`admin/location?no_paginate=True`)
            .then((res) => res.data)
            .then((data) => {
                let dataRes = data.results;
                let dataTransform = dataRes.map((item) => ({
                    id: item.id,
                    name: item.name,
                    valor: item.id,
                }));
                setDataLocation(Number(dataTransform[0].id));
                setListLocations(dataTransform);
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setIsLoading(false);
            });
    }

    async function getData() {
        try {
            setIsLoading(true);
            const response = await instanceMob.get(
                `admin/metrics/schedules?service_id=${dataService}&location_id=${dataLocation}&date_range=${frecuency}`
            );
            const data = response.data;

            if (data.matrix && data.matrix.length > 0) {
                setData(data.matrix);
                setMaxValue(data?.max || 0);
            }
        } catch (err) {
            const msg_error = err?.response?.data;
            setData([]);
            if (msg_error) {
            }
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        picker();
    }, [dateRange]);

    useEffect(() => {
        getListServices();
        getListLocations();
    }, []);

    useEffect(() => {
        if (dataService > 0 && dataLocation > 0 && frecuency) {
            getData();
        }
    }, [dataService, dataLocation, frecuency]);

    useEffect(() => {
        if (menuRef.current) {
            setHasScroll(menuRef.current.scrollHeight > menuRef.current.clientHeight);
        }
    }, [listServices, isServiceOpen]);

    return (
        <div className="mx-auto" style={{width: "100%", height: "80%"}}>
            {modalError}
            <div className="w-100" style={{height: "10%"}}>
                <div className="w-100 d-flex justify-content-between align-items-center h-100">
                    <div
                        style={{width: "90%"}}
                        className="d-flex mx-auto gap-3 justify-content-center h-100"
                    >
                        <div className="dropdown text-center position-relative">
                            <button
                                className="btn dropdown-toggle card-select d-flex justify-content-between align-items-center"
                                type="button"
                                id="servicesDropdown"
                                aria-expanded={isServiceOpen}
                                onClick={() => setIsServiceOpen(!isServiceOpen)}
                            >
                                    <span>
                                      {dataService === listServices[0]?.valor
                                          ? listServices[0].name
                                          : listServices.find((s) => s?.valor === dataService)?.name ||
                                          "Selecciona"}
                                    </span>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: `<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.26912 8.89571C6.91484 8.89571 6.56051 8.76057 6.29014 8.49022L0.925015 3.12509C0.38437 2.58444 0.38437 1.70785 0.925015 1.16719C1.46564 0.62656 2.34226 0.62656 2.88289 1.16719L7.26912 5.55347L11.6553 1.16719C12.196 0.62656 13.0726 0.62656 13.6132 1.16719C14.1539 1.70785 14.1539 2.58444 13.6132 3.12509L8.2481 8.49022C7.97775 8.76057 7.6234 8.89571 7.26912 8.89571Z" fill="#9DACBD"/></svg>`,
                                    }}
                                />
                            </button>
                            <ul
                                ref={menuRef}
                                className={`dropdown-menu w-100 card-select-menu p-2 ${
                                    hasScroll ? "pe-0" : ""
                                } ${isServiceOpen ? "show" : ""}`}
                                aria-labelledby="servicesDropdown"
                            >
                                {listServices.map((s) => (
                                    <li
                                        key={s.valor}
                                        className={`card-select-label dropdown-item ${
                                            dataService === s.valor ? "active" : ""
                                        }`}
                                        onClick={() => {
                                            setDataService(s.valor);
                                            setIsServiceOpen(false);
                                        }}
                                        style={{cursor: "pointer"}}
                                        title={s.name}
                                    >
                                        {s.name}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="dropdown text-center position-relative">
                            <button
                                className="btn dropdown-toggle card-select d-flex justify-content-between align-items-center"
                                type="button"
                                id="locationDropdown"
                                aria-expanded={isLocationOpen}
                                onClick={() => setIsLocationOpen(!isLocationOpen)}
                            >
                                    <span>
                                          {dataLocation === listLocations[0]?.valor
                                              ? listLocations[0].name
                                              : listLocations.find((l) => l?.valor === dataLocation)?.name ||
                                              "Selecciona"}
                                    </span>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: `<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.26912 8.89571C6.91484 8.89571 6.56051 8.76057 6.29014 8.49022L0.925015 3.12509C0.38437 2.58444 0.38437 1.70785 0.925015 1.16719C1.46564 0.62656 2.34226 0.62656 2.88289 1.16719L7.26912 5.55347L11.6553 1.16719C12.196 0.62656 13.0726 0.62656 13.6132 1.16719C14.1539 1.70785 14.1539 2.58444 13.6132 3.12509L8.2481 8.49022C7.97775 8.76057 7.6234 8.89571 7.26912 8.89571Z" fill="#9DACBD"/></svg>`,
                                    }}
                                />
                            </button>
                            <ul
                                className={`dropdown-menu w-100 card-select-menu p-2 ${
                                    isLocationOpen ? "show" : ""
                                }`}
                                aria-labelledby="locationDropdown"
                            >
                                {listLocations.map((l) => (
                                    <li
                                        key={l?.valor}
                                        className={`card-select-label dropdown-item ${
                                            dataLocation === l?.valor ? "active" : ""
                                        }`}
                                        onClick={() => {
                                            setDataLocation(l?.valor);
                                            setIsLocationOpen(false);
                                        }}
                                        style={{cursor: "pointer"}}
                                    >
                                        {l.name}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="dropdown text-center position-relative">
                            <button
                                className="btn dropdown-toggle card-select d-flex justify-content-between align-items-center"
                                type="button"
                                id="frecuencyDropdown"
                                aria-expanded={isFrecuencyOpen}
                                onClick={() => setIsFrecuencyOpen(!isFrecuencyOpen)}
                            >
                                    <span>
                                          {frecuency === dataFrecuency[0]?.valor
                                              ? dataFrecuency[0].name
                                              : dataFrecuency.find((f) => f?.valor === frecuency)?.name ||
                                              "Selecciona"}
                                    </span>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: `<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.26912 8.89571C6.91484 8.89571 6.56051 8.76057 6.29014 8.49022L0.925015 3.12509C0.38437 2.58444 0.38437 1.70785 0.925015 1.16719C1.46564 0.62656 2.34226 0.62656 2.88289 1.16719L7.26912 5.55347L11.6553 1.16719C12.196 0.62656 13.0726 0.62656 13.6132 1.16719C14.1539 1.70785 14.1539 2.58444 13.6132 3.12509L8.2481 8.49022C7.97775 8.76057 7.6234 8.89571 7.26912 8.89571Z" fill="#9DACBD"/></svg>`,
                                    }}
                                />
                            </button>
                            <ul
                                className={`dropdown-menu w-100 card-select-menu p-2 ${
                                    isFrecuencyOpen ? "show" : ""
                                }`}
                                aria-labelledby="frecuencyDropdown"
                            >
                                {dataFrecuency.map((f) => (
                                    <li
                                        key={f?.valor}
                                        className={`card-select-label dropdown-item ${
                                            frecuency === f?.valor ? "active" : ""
                                        }`}
                                        onClick={() => {
                                            setFrecuency(f?.valor);
                                            setIsFrecuencyOpen(false);
                                        }}
                                        style={{cursor: "pointer"}}
                                    >
                                        {f.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {isLoading ? (
                <div className="mx-auto" style={{width: "90%", height: "90%"}}>
                    <div className="d-flex align-items-center justify-content-center w-100 h-100">
                        <Loadingspinner size={50}/>
                    </div>
                </div>
            ) : (
                <div className="mx-auto" style={{width: "90%", height: "80%"}}>
                    <div className="d-flex mt-2 align-items-center w-100 justify-content-center">
                        <span
                            className="fw-bold"
                            style={{fontSize: "calc(0.4rem + 0.4vw)", color: "var(--elevvaTextTitle)"}}
                        >
                            Horarios
                        </span>
                    </div>
                    {data.length > 0 ? (
                        <PerfectScrollbar
                            style={{height: "100%"}}
                            className="m-auto w-100"
                        >
                            <div className="container p-3">
                                <div className="d-flex">
                                    <div style={{width: "5rem"}}></div>

                                    {["DOM", "LUN", "MAR", "MIE", "JUE", "VIE", "SAB"].map(
                                        (dia, idx) => (
                                            <div
                                                key={idx}
                                                className="text-center fw-bold text-secondary"
                                                style={{flex: 1}}
                                            >
                                                {dia}
                                            </div>
                                        )
                                    )}
                                </div>

                                {data.map((item, i) => {
                                    const hour = item.time;

                                    return (
                                        <div className="d-flex align-items-center" key={i}>
                                            <div
                                                className="text-end text-secondary"
                                                style={{width: "5rem", fontSize: "12px"}}
                                            >
                                                {moment(hour, "HH:mm").format("hh:mm a")}
                                            </div>
                                            {[...Array(7)].map((_, j) => {
                                                const countValue = item[j + 1];
                                                const calculateValue = (100 * countValue) / maxValue;
                                                const backgroundColor =
                                                    calculateValue >= 90
                                                        ? "rgba(0, 58, 72, 1)"
                                                        : calculateValue >= 70
                                                            ? "rgba(0, 109, 134,1)"
                                                            : calculateValue >= 50
                                                                ? "rgba(0, 162, 213,1)"
                                                                : calculateValue >= 30
                                                                    ? "rgba(92, 218, 247,1)"
                                                                    : "rgba(172, 229, 250,1)";

                                                const tooltip = (
                                                    <Tooltip>
                                                        <div>
                                                            <strong>
                                                                Hora {moment(hour, "HH:mm").format("hh:mm a")}
                                                            </strong>
                                                        </div>
                                                        <div>{countValue} reserva(s)</div>
                                                    </Tooltip>
                                                );

                                                return (
                                                    <Whisper
                                                        key={j}
                                                        trigger="hover"
                                                        placement="top"
                                                        speaker={tooltip}
                                                    >
                                                        <div
                                                            className="border relative"
                                                            style={{
                                                                flex: 1,
                                                                height: "24px",
                                                                backgroundColor,
                                                                borderRadius: "2px",
                                                                margin: "1px",
                                                            }}
                                                        />
                                                    </Whisper>
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                            </div>
                        </PerfectScrollbar>
                    ) : (
                        <div className="d-flex align-items-center flex-column justify-content-center w-100 h-100">
                            <img
                                alt="logo_alta_black_2"
                                style={{padding: "0% 20%"}}
                                src={
                                    process.env.PUBLIC_URL +
                                    "/assets/img/logo_small_elevva_metrics.png"
                                }
                            />
                            <span>No hay datos</span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
